export const managerOptions = (users) => {
  return users.map((u) => ({ value: u.id, name: u.name }));
};
